import { combineEpics } from 'redux-observable'
import { buyCryptoCreateOrderEpic } from 'components/features/rewards/rewardsPane/store/epics/buyMode/buyCryptoCreateOrder'

export const rewardsPaneBuyModeEpic = combineEpics(
  buyCryptoCreateOrderEpic,
)
